// extracted by mini-css-extract-plugin
export default {"wrapper":"SharePosition_wrapper__n+wGc","container":"SharePosition_container__dy0pL","spinner":"SharePosition_spinner__gfEBG"};